export type NewsTag = "影视动态" | "行业深度" | "明星访谈";

export interface NewsArticle {
  id: string;
  title: string;
  tag: NewsTag;
  date: string;
  summary: string;
  cover: string;
  content: string[];
}

export const newsList: NewsArticle[] = [
  {
    id: "2025-autumn-slate",
    title: "2025 秋季国产片单发布：类型多元，现实题材受关注",
    tag: "影视动态",
    date: "2025-10-12",
    summary: "多家片方集中公布秋季片单，涵盖科幻、悬疑、家庭等题材，现实题材作品数量明显上升。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20film%20reels%20and%20warm%20spotlights%20on%20a%20dark%20stage%2C%20editorial%20magazine%20style%2C%20warm%20vermillion%20and%20charcoal%20tones%2C%20artistic%20photography%2C%20no%20text&width=800&height=500&seq=news-cover-01&orientation=landscape",
    content: [
      "随着秋季档期临近，多家影视公司陆续公布了新一批国产影片片单。与往年相比，本次片单在类型分布上更加多元，科幻、悬疑、历史与家庭题材均有代表性作品入选。",
      "业内观察人士指出，现实题材作品的数量较往年有明显上升，越来越多创作者把镜头对准普通人的生活与情感。这类作品往往成本可控、口碑扎实，正逐渐成为市场的重要力量。",
      "此外，多部中等成本影片选择在非热门档期上映，试图通过精准的口碑运营获得更长的放映周期。这一策略能否奏效，还有待市场的进一步检验。",
    ],
  },
  {
    id: "sci-fi-production",
    title: "国产科幻再进阶：从概念设计到工业化制作",
    tag: "行业深度",
    date: "2025-10-09",
    summary: "从美术概念到后期视效，国产科幻电影的制作流程正在走向成熟与标准化。",
    cover: "https://readdy.ai/api/search-image?query=Concept%20art%20studio%20with%20holographic%20spaceship%20designs%20glowing%20on%20screens%2C%20creative%20production%20atmosphere%2C%20deep%20teal%20with%20warm%20orange%20accents%2C%20editorial%20style%2C%20no%20text&width=800&height=500&seq=news-cover-02&orientation=landscape",
    content: [
      "近年来，国产科幻电影在视觉呈现上的进步有目共睹。这背后，是一整套制作流程从探索走向成熟的缩影。",
      "过去，许多项目直到拍摄阶段才开始考虑视效，导致后期返工频繁。如今，越来越多团队在剧本阶段就引入概念设计与视效预览，把“能不能拍”提前变成“怎么拍”。",
      "与此同时，本土视效公司逐步积累起自己的资产库与制作标准，成本与周期的可控性显著提升。可以说，国产科幻正在从单点突破走向体系化的工业化生产。",
    ],
  },
  {
    id: "director-interview-han",
    title: "专访导演韩振国：我想拍普通人身上的光",
    tag: "明星访谈",
    date: "2025-10-06",
    summary: "聊创作、聊演员、聊时代，导演韩振国分享了他对现实题材的理解与坚持。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20interview%20room%20with%20a%20director%20chair%20and%20soft%20studio%20lighting%2C%20editorial%20portrait%20atmosphere%2C%20warm%20amber%20and%20muted%20earth%20tones%2C%20cinematic%20style%2C%20no%20text&width=800&height=500&seq=news-cover-03&orientation=landscape",
    content: [
      "在《烽火长河》收获口碑之后，导演韩振国并没有急着投入更大的项目，而是回到了他熟悉的现实题材。",
      "“我不想只拍大场面，”他在采访中说，“我更想拍普通人身上的那点光。哪怕很微弱，也值得被看见。”",
      "谈到与演员的合作，他表示自己更看重演员对生活的理解：“技巧可以磨，但对人的理解是装不出来的。”在他看来，一部作品能否打动观众，最终还是取决于创作者有没有真诚地面对生活。",
    ],
  },
  {
    id: "tvseries-market",
    title: "2025 国产剧集观察：短剧集与精品化并行",
    tag: "行业深度",
    date: "2025-10-03",
    summary: "剧集市场呈现两极趋势：短小精悍的迷你剧与投入更高的精品长剧同台竞技。",
    cover: "https://readdy.ai/api/search-image?query=Row%20of%20televisions%20in%20a%20dark%20gallery%20displaying%20warm%20glowing%20scenes%2C%20editorial%20technology%20style%2C%20warm%20vermillion%20and%20charcoal%20tones%2C%20no%20text&width=800&height=500&seq=news-cover-04&orientation=landscape",
    content: [
      "今年的国产剧集市场呈现出鲜明的两极分化：一边是 12 至 24 集的迷你剧凭借紧凑节奏赢得口碑，另一边是投入更高的精品长剧继续稳固基本盘。",
      "迷你剧的兴起与观众观剧习惯的变化密切相关。在碎片化的时间里，观众更希望用有限的时间获得完整的叙事体验。",
      "而精品长剧则在制作水准上不断加码，服化道、摄影与配乐的工业化程度稳步提升。业内人士认为，两条路线并非对立，而是共同丰富了国产剧集的生态。",
    ],
  },
  {
    id: "festival-awards",
    title: "国产影片亮相国际影展，多部作品入围主竞赛",
    tag: "影视动态",
    date: "2025-09-29",
    summary: "多部国产电影入围国际影展主竞赛单元，题材横跨历史、家庭与科幻。",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20at%20night%20with%20spotlights%20and%20glowing%20marquee%2C%20film%20festival%20atmosphere%2C%20warm%20red%20and%20gold%20tones%2C%20cinematic%20style%2C%20no%20text&width=800&height=500&seq=news-cover-05&orientation=landscape",
    content: [
      "本季多个国际影展公布了入围名单，多部国产影片进入主竞赛单元，涵盖历史、家庭与科幻等不同题材。",
      "其中既有知名导演的新作，也有年轻创作者的处女长片。国际选片人对国产影片在叙事语言上的探索给予了积极评价。",
      "业内人士表示，走出去不仅是荣誉，更是交流与学习的机会。通过影展平台，国产影片有机会接触更广阔的观众与市场。",
    ],
  },
  {
    id: "actress-interview-yun",
    title: "演员云初谈古装角色：让表演有呼吸感",
    tag: "明星访谈",
    date: "2025-09-25",
    summary: "从《锦绣长歌》说起，演员云初分享了她对古装表演与人物塑造的心得。",
    cover: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20silk%20costume%20detail%20with%20delicate%20embroidery%20under%20soft%20warm%20lighting%2C%20editorial%20textile%20photography%2C%20deep%20red%20and%20gold%20tones%2C%20no%20text&width=800&height=500&seq=news-cover-06&orientation=landscape",
    content: [
      "在《锦绣长歌》中，云初塑造的女主角收获了观众的广泛认可。谈及这个角色，她坦言最大的挑战是“克制”。",
      "“古装剧容易用力过猛，”她说，“我一直在提醒自己，让表演有呼吸感，把情绪收一点，观众反而能感受到更多。”",
      "为了更好地理解人物，她查阅了大量史料，并和编剧反复沟通角色的成长逻辑。在她看来，只有真正理解人物所处的时代，表演才能立得住。",
    ],
  },
  {
    id: "box-office-review",
    title: "国庆档复盘：口碑如何影响票房长尾",
    tag: "行业深度",
    date: "2025-09-22",
    summary: "复盘国庆档，口碑与票房的关联愈发紧密，长尾效应成为关键变量。",
    cover: "https://readdy.ai/api/search-image?query=Cinema%20auditorium%20with%20warm%20ambient%20lighting%20and%20rows%20of%20empty%20seats%2C%20editorial%20cinematic%20style%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20no%20text&width=800&height=500&seq=news-cover-07&orientation=landscape",
    content: [
      "国庆档落下帷幕，多部影片的票房表现再度印证了口碑的重要性。开画首日不再决定一切，长线放映能力成为新的竞争焦点。",
      "数据显示，评分较高的影片往往在上映第二周仍能保持稳定的上座率，而口碑不佳的影片则快速缩水。",
      "这一趋势促使片方更加重视点映与口碑发酵策略，也让创作者意识到，内容质量才是决定作品生命力的根本。",
    ],
  },
  {
    id: "new-gen-actors",
    title: "新生代演员群像：他们为何选择现实题材",
    tag: "明星访谈",
    date: "2025-09-18",
    summary: "几位新生代演员谈及选角偏好，不约而同提到对现实题材的兴趣。",
    cover: "https://readdy.ai/api/search-image?query=Group%20of%20young%20actors%20in%20a%20rehearsal%20studio%20with%20warm%20natural%20light%2C%20editorial%20portrait%20atmosphere%2C%20warm%20neutral%20earth%20tones%2C%20cinematic%20style%2C%20no%20text&width=800&height=500&seq=news-cover-08&orientation=landscape",
    content: [
      "在近期的多场采访中，几位新生代演员不约而同地表达了对现实题材的偏爱。",
      "“现实题材让我更贴近生活本身，”其中一位演员说，“它逼着你去看、去感受，而不是只靠想象。”",
      "分析人士认为，这既与市场的供给变化有关，也反映出年轻演员对长期表演生涯的规划——他们更希望用扎实的角色积累口碑，而非追逐短期的流量。",
    ],
  },
  {
    id: "behind-scenes-art",
    title: "幕后揭秘：一部国产电影的美术如何诞生",
    tag: "影视动态",
    date: "2025-09-14",
    summary: "走进美术团队的工作现场，看一部电影的场景与质感如何被一点点搭建出来。",
    cover: "https://readdy.ai/api/search-image?query=Art%20department%20workshop%20with%20miniature%20sets%2C%20paintbrushes%20and%20sketches%20under%20warm%20task%20lighting%2C%20craft%20editorial%20style%2C%20warm%20earth%20tones%2C%20no%20text&width=800&height=500&seq=news-cover-09&orientation=landscape",
    content: [
      "一部电影的质感，往往藏在观众未必留意的细节里。美术团队的工作，正是为这些细节奠定基础。",
      "从概念草图到实体搭建，再到陈设与做旧，每一个环节都需要反复推敲。主创表示，最重要的不是“好看”，而是“可信”。",
      "“观众不一定知道我们做了什么，”美术指导说，“但如果做得不到位，他们一定能感觉到。”这种对真实的追求，正是国产电影工业化进程中的一个缩影。",
    ],
  },
];